import type { ThemeDefinition } from './types';

export const boldMagazine: ThemeDefinition = {
  variables: {
    '--report-font-display': "system-ui, -apple-system, 'Segoe UI', sans-serif",
    '--report-font-body': "system-ui, -apple-system, 'Segoe UI', sans-serif",
    '--report-bg': '#1a1a1a',
    '--report-bg-surface': '#262626',
    '--report-text': '#ffffff',
    '--report-text-secondary': '#d4d4d4',
    '--report-text-muted': '#a3a3a3',
    '--report-accent': '#ff6b35',
    '--report-accent-dim': 'rgba(255, 107, 53, 0.15)',
    '--report-border': '#404040',
    '--report-border-strong': '#525252',
    '--report-stat-color': '#ffffff',
    '--report-stat-positive': '#4ade80',
    '--report-stat-negative': '#f87171',
    '--report-callout-bg': '#262626',
    '--report-callout-border': '#ff6b35',
    '--report-surface-hover': '#333333',
    '--report-code-bg': '#262626',
    '--report-code-text': '#ff6b35',
    '--report-measure': '780px',
  },
};
